import styled from 'shared/utils/styled';

import { CaseStatuses } from 'utils/enums';

type StatusAccessories = Partial<{
  status: CaseStatuses | null;
}>;

export const CaseNumber = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(20),
}));

export const Status = styled('span', {
  shouldForwardProp: (prop) => prop !== 'status',
})<StatusAccessories>(({ status, theme }) => ({
  ...(status && {
    color: [CaseStatuses.Approved, CaseStatuses.Completed].includes(status)
      ? theme.palette.success.main
      : [CaseStatuses.Canceled, CaseStatuses.Rejected].includes(status)
      ? theme.palette.error.main
      : theme.palette.primary.main,
  }),
}));
